"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 26 26" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M24.3133 19.4513L14.7411 2.51588C13.9755 1.16137 12.0245 1.16137 11.2589 2.51589L1.68668 19.4513C0.933104 20.7846 1.89633 22.4354 3.42781 22.4354H22.5722C24.1037 22.4354 25.0669 20.7846 24.3133 19.4513Z", stroke: fill2, strokeWidth: "1", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M13 7.5V15.5", stroke: fill2, strokeWidth: "1", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("circle", { cx: "13", cy: "18", r: "0.5", fill: fill2 }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? 'black' : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 34 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M32.0845 25.9351L19.3215 3.35451C18.3007 1.54849 15.6993 1.5485 14.6785 3.35452L1.91559 25.9351C0.910826 27.7128 2.19512 29.9139 4.2371 29.9139H29.763C31.8049 29.9139 33.0892 27.7128 32.0845 25.9351Z", stroke: fill2, strokeWidth: "1.5", fill: fill }, void 0),
            jsx_runtime_1.jsx("path", { d: "M17 10V20.6667", stroke: fill2, strokeWidth: "1.5", strokeLinecap: "round" }, void 0),
            jsx_runtime_1.jsx("path", { d: "M17 24V24.0133", stroke: fill2, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }, void 0)] }), void 0));
};
var WarningIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.WarningIcon = WarningIcon;
//# sourceMappingURL=WarningIcon.js.map